import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BesharpTopbarComponent, BesharpTopbarItems } from '../../modules/besharp-topbar/besharp-topbar.component';
import { ButtonModule } from 'primeng/button';
import { ChatApiService } from '../../services/chat-api.service';
import { SessionsService } from '../../modules/besharp-sessions/lib/services/sessions.service';

@Component({
  selector: 'app-simple-layout',
  imports: [RouterOutlet, BesharpTopbarComponent, ButtonModule],
  providers: [MessageService, ConfirmationService],
  templateUrl: './simple-layout.component.html',
  styleUrls: ['./simple-layout.component.scss'],
})
export class SimpleLayoutComponent implements OnInit {
  private readonly router: Router = inject(Router);
  protected title = 'Datahub AI';
  protected logo = '/images/logo.svg';
  protected homeRoute = '/app';
  protected topBarItems!: BesharpTopbarItems;
  protected isBackendConnected = false;
  protected isCheckingBackendHealth = false;
  private healthCheckIntervalId?: number;

  private readonly chatApiService = inject(ChatApiService);
  private readonly sessionsService = inject(SessionsService);

  async ngOnInit(): Promise<void> {
    this.topBarItems = {
      itemsSize: 'xs',
      items: [
        {
          icon: 'pi pi-sun',
          iconPosition: 'left',
          outlined: true,
          command: () => this.toggleDarkMode(),
          severity: 'success',
        },
        {
          icon: 'pi pi-sign-out',
          iconPosition: 'left',
          outlined: true,
          command: () => this.goToSessionSelector(),
          severity: 'secondary',
        },
      ],
    };
    await this.checkBackendHealth();
    this.startHealthCheckPolling();
  }

  private async checkBackendHealth(): Promise<void> {
    this.isCheckingBackendHealth = true;
    try {
      await this.chatApiService.checkHealth();
      this.isBackendConnected = true;
    } catch {
      this.isBackendConnected = false;
    } finally {
      this.isCheckingBackendHealth = false;
    }
  }
  toggleDarkMode(): void {
    const element = document.querySelector('html');
    element!.classList.toggle('dark-mode');
    const isDark = element!.classList.contains('dark-mode');
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
  }
  protected async refreshBackendHealth(): Promise<void> {
    await this.checkBackendHealth();
  }

  goToSessionSelector(): void {
    const sessions = this.sessionsService.getSessions();
    sessions.forEach((session) => {
      this.sessionsService.removeSession(session.id);
    });

    this.router.navigate(['/session/signin']);
  }
  private startHealthCheckPolling(): void {
    if (this.healthCheckIntervalId !== undefined) {
      window.clearInterval(this.healthCheckIntervalId);
    }

    this.healthCheckIntervalId = window.setInterval(() => {
      void this.checkBackendHealth();
    }, 10000);
  }
}
